import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddTechdocsStyling } from './AddTechdocsStyling';

const customTechdocsStylingAddon = AddonBlueprint.make({
  name: 'custom-styling',
  params: {
    name: 'CustomTechdocsStyling',
    location: TechDocsAddonLocations.Content,
    component: AddTechdocsStyling,
  },
});

export default createFrontendModule({
  pluginId: 'techdocs',
  extensions: [customTechdocsStylingAddon],
});
